import Vue from 'vue';
import Route from 'vue-router';

Vue.use(Route);

const originalPush = Route.prototype.push;

Route.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const routes = [{
        path: '/',
        name: 'App',
        redirect: '/home'
    },
    {
        name: 'home',
        path: '/home',
        component: () => import('../pages/business/home.vue'),
        meta: {}
    },

    {
        name: 'unitIntroduction',
        path: '/unit-introduction',
        component: () => import('../pages/business/unit-introduction.vue'),
        meta: {}
    },

    {
        name: 'test-service',
        path: '/test-service',
        component: () => import('../pages/business/test-service.vue'),
        meta: {
            showTestService: true
        },
        children: [{
                name: 'test-service-online-delegation',
                path: 'test-service-online-delegation',
                component: () => import('../pages/business/test-service-online-delegation.vue'),
                meta: {
                    showTestService: false
                }
            },
            {
                name: 'test-service-detail',
                path: 'test-service-detail',
                component: () => import('../pages/business/test-service-detail.vue'),
                meta: {
                    showTestService: false
                }
            }
        ]
    },
    {
        name: 'cigarette',
        path: '/cigarette',
        component: () => import('../pages/business/cigarette.vue'),
        meta: {
            showCigarette: true
        },
        children: [{
                name: 'cigarette-entrust',
                path: 'cigarette-entrust',
                component: () => import('../pages/business/cigarette-entrust.vue'),
                meta: {
                    showCigarette: true,
                }
            },
            {
                name: 'cigarette-guidelines',
                path: 'cigarette-guidelines',
                component: () => import('../pages/business/cigarette-guidelines.vue'),
                meta: {
                    showCigarette: true
                }
            },
            {
                name: 'cigarette-online-delegation',
                path: 'cigarette-online-delegation',
                component: () => import('../pages/business/test-service-online-delegation.vue'),
                meta: {
                    showCigarette: false,
                    isCigarette: true
                }
            }
        ]
    },
    {
        name: 'cigarette-detail',
        path: 'cigarette-detail',
        component: () => import('../pages/business/test-service-detail.vue'),
        meta: {
            showCigarette: true,
            isCigarette: true
        }
    },
    {
        name: 'login',
        path: '/login',
        component: () => import('../pages/login/login.vue')
    },
    {
        name: 'register',
        path: '/register',
        component: () => import('../pages/login/register.vue')
    },
    {
        name: 'personalCenter',
        path: '/personal-center',
        component: () => import('../pages/user/personal-center.vue'),
        meta: {
            hideHomeTab: false
        }
    },
    {
        name: 'queryService',
        path: '/query-service',
        component: () => import('../pages/query-service/index.vue'),
        redirect: '/query-service/entrust-query',
        meta: {
            showQueryService: true
        },
        children: [{
                name: 'entrustQuery',
                path: 'entrust-query',
                component: () => import('../pages/query-service/entrust-query.vue'),
                meta: {
                    showQueryService: true
                }
            },
            {
                name: 'reportQuery',
                path: 'report-query',
                component: () => import('../pages/query-service/report-query.vue'),
                meta: {
                    showQueryService: true
                }
            },
            {
                name: 'resultDetail',
                path: 'result-detail',
                component: () => import('../pages/query-service/components/result-detail.vue'),
                meta: {
                    showQueryService: false
                }
            },
            {
                name: 'logisticsInfo',
                path: 'logistics-info',
                component: () => import('../pages/query-service/components/logistics-info.vue'),
                meta: {
                    showQueryService: false
                }
            }
        ]
    },
    {
        name: 'sample',
        path: '/sample',
        component: () => import('../pages/sample/index.vue'),
        redirect: '/sample/sample-order',
        meta: {
            showSample: true
        },
        children: [{
                name: 'sampleSearch',
                path: 'sample-search',
                component: () => import('../pages/sample/sample-search.vue'),
                meta: {
                    showSample: true
                }
            },
            {
                name: 'sampleOrder',
                path: 'sample-order',
                component: () => import('../pages/sample/sample-order.vue'),
                meta: {
                    showSample: true
                }
            },
            {
                name: 'sampleMakeOrder',
                path: 'sample-make-order',
                component: () => import('../pages/sample/sample-make-order.vue'),
                meta: {
                    showSample: false
                }
            },
            {
                name: 'sampleDetail',
                path: 'sample-detail',
                component: () => import('../pages/sample/sample-detail.vue'),
                meta: {
                    showSample: false
                }
            }
        ]
    },
    {
        name: 'notification',
        path: '/notification',
        component: () => import('../pages/business/notification.vue'),
        meta: {}
    },
    {
        name: 'download',
        path: '/download',
        component: () => import('../pages/business/download.vue'),
        meta: {}
    }
];

const route = new Route({
    base: '/',
    routes
});

const whiteList = ['login', 'register', 'home', 'reportQuery', 'sampleSearch', 'unitIntroduction', 'notification', 'test-service', 'cigarette', 'sample', 'query-service', 'cigarette-entrust', 'cigarette-guidelines', 'sampleOrder', 'download'];

route.beforeEach((to, from, next) => {
    if (whiteList.includes(to.name)) {
        next();
    } else {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        let isLogin = userInfo !== null;
        if (!isLogin) {
            Vue.prototype.$warning({
                title: '警告',
                content: '登录已过期，请重新登录',
                onOk() {
                    next('/home');
                }
            });
        } else {
            next();
        }
    }
});

export default route;